import { render, staticRenderFns } from "./recallNoticeTask.vue?vue&type=template&id=7b1150b8&scoped=true"
import script from "./recallNoticeTask.vue?vue&type=script&lang=js"
export * from "./recallNoticeTask.vue?vue&type=script&lang=js"
import style0 from "./recallNoticeTask.vue?vue&type=style&index=0&id=7b1150b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1150b8",
  null
  
)

export default component.exports